import React, { useState, useEffect, useCallback } from 'react';
import { getVioExternalKeyStatus } from '../services/api';
import VioExternalApiKeyModal from './VioExternalApiKeyModal';

/**
 * After auth, require a VIO External API key for this tenant (LowDB, via ops UI).
 * Same flow as luckydraw-v4 ops portal.
 */
export default function VioExternalApiKeyGate({ children }) {
  const [phase, setPhase] = useState('loading');
  const [statusError, setStatusError] = useState(null);

  const check = useCallback(async () => {
    setPhase('loading');
    setStatusError(null);
    try {
      const res = await getVioExternalKeyStatus();
      if (!res.success) {
        setPhase('blocked');
        setStatusError(res.message || 'Could not load API key status');
        return;
      }
      if (res.data?.configured) {
        setPhase('ready');
      } else {
        setPhase('blocked');
      }
    } catch (e) {
      const msg = e?.response?.data?.message || e.message || 'Could not load API key status';
      setPhase('blocked');
      setStatusError(msg);
    }
  }, []);

  useEffect(() => {
    check();
  }, [check]);

  const onSaved = useCallback(() => {
    check();
  }, [check]);

  if (phase === 'loading') {
    return (
      <div className="vio-key-gate-loading">
        <div className="vio-key-gate-spinner" />
        <p className="vio-key-gate-loading-text">
          Checking VIO External API configuration…
        </p>
      </div>
    );
  }

  if (phase === 'ready') {
    return <>{children}</>;
  }

  return (
    <VioExternalApiKeyModal
      opened
      allowDismiss={false}
      statusError={statusError}
      onClose={() => {}}
      onSaved={onSaved}
      onRetryStatus={() => check()}
    />
  );
}
